import dayjs from 'dayjs';
import 'dayjs/locale/id';

dayjs.locale('id');

export default function formatDuration(start, end, paramFormat = {}) {
  const defaultFormat = { date: 'D', month: 'MMM', year: 'YYYY' };
  const formatter = { ...defaultFormat, ...paramFormat };
  const startDate = dayjs(start);
  const endDate = dayjs(end);
  const { date, month, year } = formatter;

  if (startDate.isSame(endDate)) {
    return startDate.format(`${date} ${month} ${year}`);
  }

  const isDifferentYear = startDate.year() !== endDate.year();
  const isDifferentMonth = startDate.month() !== endDate.month();

  const formatFirstMonth = isDifferentMonth || isDifferentYear ? ` ${month}` : '';
  const formatFirstYear = isDifferentYear ? ` ${year}` : '';
  const formatFirstDate = `${date}${formatFirstMonth}${formatFirstYear}`;

  return `${startDate.format(formatFirstDate)} - ${endDate.format(`${date} ${month} ${year}`)}`;
}
